// util/constants.js
export const SENTIMENT_METRIC_ID = "7";
export const PORTCO_TWITTER_LIST_ID="1671508043656208385";
export const FOUNDER_TWITTER_LIST_ID="1671514856342650881";
export const PITCHBOOK_INSIGHTS="insights";
export const PITCHBOOK_CONTACT_INFO="contact-info";
export const PITCHBOOK_INVESTORS="investors";
